import { render, staticRenderFns } from "./DealTermsAndFeatures.vue?vue&type=template&id=180d0b69&scoped=true&"
import script from "./DealTermsAndFeatures.vue?vue&type=script&lang=js&"
export * from "./DealTermsAndFeatures.vue?vue&type=script&lang=js&"
import style0 from "./DealTermsAndFeatures.vue?vue&type=style&index=0&id=180d0b69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180d0b69",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GuaranteeText: require('/app/appsumo/nuxt/components/pdp/GuaranteeText.vue').default,DealPropertyList: require('/app/appsumo/nuxt/components/products/terms-and-features/DealPropertyList.vue').default})
